export default __webpack_public_path__ + "locales/es/UploadPanel.json?hash=ba0954e9886754ef7bfc111021a058f4";